import React, { useState, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";

export const Countdown = ({ target }) => {
  const { t } = useLang();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = new Date(target).getTime() - now;
  if (isNaN(diff) || diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const Cell = ({ v, l }) => (
    <div className="flex flex-col items-center min-w-[48px]">
      <span className="font-serif text-3xl sm:text-4xl text-indigo-100 tabular-nums">{String(v).padStart(2, "0")}</span>
      <span className="font-mono text-[10px] uppercase tracking-wider text-indigo-300/70 mt-1">{l}</span>
    </div>
  );
  const Sep = () => <span className="text-indigo-400/40 text-2xl -mt-3">:</span>;
  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="event-countdown">
      <Cell v={d} l={t("cd_d")} />
      <Sep />
      <Cell v={h} l={t("cd_h")} />
      <Sep />
      <Cell v={m} l={t("cd_m")} />
      <Sep />
      <Cell v={s} l={t("cd_s")} />
    </div>
  );
};

export default Countdown;
